const _accessories = {
	'3d-glasses': {
		name: '3D Glasses',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	bandage: {
		name: 'Bandage',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 35,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 140,
			},
		],
		variations: {
			beige: 'Beige',
		},
	},
	beak: {
		name: 'Beak',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			yellow: 'Yellow',
		},
	},
	'birthday-shades': {
		name: 'Birthday Shades',
		sellPrice: {
			currency: 'bells',
			value: 620,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2480,
			},
		],
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			red: 'Red',
			blue: 'Blue',
		},
	},
	'bottom-rimmed-glasses': {
		name: 'Bottom-rimmed Glasses',
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			red: 'Red',
			purple: 'Purple',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
			black: 'Black',
		},
	},
	'browline-glasses': {
		name: 'Browline Glasses',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			black: 'Black',
			brown: 'Brown',
			green: 'Green',
			gray: 'Gray',
		},
	},
	bubblegum: {
		name: 'Bubblegum',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 35,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 140,
			},
		],
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			yellow: 'Yellow',
			green: 'Green',
			white: 'White',
		},
	},
	'bunny-nose': {
		name: 'Bunny Nose',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			white: 'White',
		},
	},
	'butterfly-shades': {
		name: 'Butterfly Shades',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			blue: 'Blue',
			red: 'Red',
			brown: 'Brown',
		},
	},
	'candy-skull-mask': {
		name: 'Candy-skull Mask',
		sellPrice: {
			currency: 'bells',
			value: 800,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 3200,
			},
		],
		variations: {
			purple: 'Purple',
			orange: 'Orange',
			blue: 'Blue',
		},
	},
	'cat-nose': {
		name: 'Cat Nose',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			white: 'White',
			brown: 'Brown',
			'navy-blue': 'Navy blue',
		},
	},
	'cucumber-pack': {
		name: 'Cucumber Pack',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			green: 'Green',
		},
	},
	'curly-mustache': {
		name: 'Curly Mustache',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 175,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 700,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'cyber-shades': {
		name: 'Cyber Shades',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			red: 'Red',
			black: 'Black',
			silver: 'Silver',
			purple: 'Purple',
			green: 'Green',
			yellow: 'Yellow',
		},
	},
	'dal-eye-mask': {
		name: 'Dal Eye Mask',
		orderable: false,
		sources: ['In the mail'],
		sellPrice: {
			currency: 'bells',
			value: 1010,
		},
		variations: {
			blue: 'Blue',
		},
	},
	'dal-sunglasses': {
		name: 'Dal Sunglasses',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 1010,
		},
		variations: {
			yellow: 'Yellow',
		},
	},
	'doctors-mask': {
		name: "Doctor's Mask",
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 35,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 140,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'dog-nose': {
		name: 'Dog Nose',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			white: 'White',
			beige: 'Beige',
			black: 'Black',
		},
	},
	'double-bridge-glasses': {
		name: 'Double-bridge Glasses',
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			gold: 'Gold',
			purple: 'Purple',
			silver: 'Silver',
			blue: 'Blue',
		},
	},
	'drinking-straw-glasses': {
		name: 'Drinking-straw Glasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			green: 'Green',
			blue: 'Blue',
			pink: 'Pink',
			white: 'White',
		},
	},
	'eye-mask': {
		name: 'Eye Mask',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			blue: 'Blue',
			pink: 'Pink',
			gray: 'Gray',
			green: 'Green',
			orange: 'Orange',
			red: 'Red',
		},
	},
	'facial-mask': {
		name: 'Facial Mask',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'eye-patch': {
		name: 'Eye Patch',
		sellPrice: {
			currency: 'bells',
			value: 35,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 140,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'fake-nose': {
		name: 'Fake Nose',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			red: 'Red',
		},
	},
	'flower-sunglasses': {
		name: 'Flower Sunglasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 192,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 770,
			},
		],
		variations: {
			red: 'Red',
			orange: 'Orange',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	'food-mess': {
		name: 'Food Mess',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			pasta: 'Pasta',
		},
	},
	'funny-glasses': {
		name: 'Funny Glasses',
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			brown: 'Brown',
			pink: 'Pink',
			blue: 'Blue',
		},
	},
	'gas-mask': {
		name: 'Gas Mask',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			black: 'Black',
			avocado: 'Avocado',
		},
	},
	'glass-bottle-glasses': {
		name: 'Glass-bottle Glasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	goatee: {
		name: 'Goatee',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 245,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 980,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	goggles: {
		name: 'Goggles',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			black: 'Black',
			blue: 'Blue',
			pink: 'Pink',
			green: 'Green',
			purple: 'Purple',
			red: 'Red',
		},
	},
	'handlebar-mustache': {
		name: 'Handlebar Mustache',
		sellPrice: {
			currency: 'bells',
			value: 280,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1120,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'heart-shades': {
		name: 'Heart Shades',
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			pink: 'Pink',
			yellow: 'Yellow',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	hmd: {
		name: 'Hmd',
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 500,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2000,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'jesters-mask': {
		name: "Jester's Mask",
		sellPrice: {
			currency: 'bells',
			value: 440,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1760,
			},
		],
		variations: {
			black: 'Black',
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
		},
	},
	'labelle-sunglasses': {
		name: 'Labelle Sunglasses',
		sellPrice: {
			currency: 'bells',
			value: 500,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2000,
			},
		],
		variations: {
			twilight: 'Twilight',
			midnight: 'Midnight',
			passion: 'Passion',
			ocean: 'Ocean',
			sunset: 'Sunset',
			love: 'Love',
		},
	},
	'ladder-shades': {
		name: 'Ladder Shades',
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			red: 'Red',
			blue: 'Blue',
			green: 'Green',
			pink: 'Pink',
			yellow: 'Yellow',
			gold: 'Gold',
		},
	},
	leaf: {
		name: 'Leaf',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 100,
		},
		recipe: {
			'clump-of-weeds': 5,
		},
		variations: {
			green: 'Green',
		},
	},
	'masquerade-mask': {
		name: 'Masquerade Mask',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 227,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 910,
			},
		],
		variations: {
			purple: 'Purple',
			black: 'Black',
			blue: 'Blue',
			red: 'Red',
			green: 'Green',
			gold: 'Gold',
		},
	},
	monocle: {
		name: 'Monocle',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			black: 'Black',
			gold: 'Gold',
			silver: 'Silver',
		},
	},
	'night-vision-goggles': {
		name: 'Night-vision Goggles',
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'nook-inc-eye-mask': {
		name: 'Nook Inc. Eye Mask',
		orderable: true,
		sources: ['Nook Miles System'],
		sellPrice: {
			currency: 'bells',
			value: 2000,
		},
		buyPrices: [
			{
				currency: 'miles',
				value: 400,
			},
		],
		variations: {
			green: 'Green',
		},
	},
	'nose-drip': {
		name: 'Nose Drip',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			'light-blue': 'Light blue',
		},
	},
	'octagonal-glasses': {
		name: 'Octagonal Glasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			gray: 'Gray',
			green: 'Green',
			purple: 'Purple',
			gold: 'Gold',
			black: 'Black',
		},
	},
	'oval-glasses': {
		name: 'Oval Glasses',
		orderable: true,
		sources: ['Nook Shopping, Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			green: 'Green',
			orange: 'Orange',
			blue: 'Blue',
			purple: 'Purple',
			magenta: 'Magenta',
			mustard: 'Mustard',
			black: 'Black',
		},
	},
	pacifier: {
		name: 'Pacifier',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			'baby-purple': 'Baby purple',
			'baby-mint': 'Baby mint',
			'baby-yellow': 'Baby yellow',
			'baby-green': 'Baby green',
			'baby-pink': 'Baby pink',
			'baby-gray': 'Baby gray',
			'baby-blue': 'Baby blue',
			'baby-orange': 'Baby orange',
		},
	},
	'pig-nose': {
		name: 'Pig Nose',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			pink: 'Pink',
		},
	},
	'pilot-shades': {
		name: 'Pilot Shades',
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			black: 'Black',
			gold: 'Gold',
		},
	},
	'pixel-shades': {
		name: 'Pixel Shades',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 330,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1320,
			},
		],
		variations: {
			red: 'Red',
			green: 'Green',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'pleather-mask': {
		name: 'Pleather Mask',
		sellPrice: {
			currency: 'bells',
			value: 192,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 770,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'post-op-patch': {
		name: 'Post-op Patch',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'privacy-mask': {
		name: 'Privacy Mask',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	reflector: {
		name: 'Reflector',
		sellPrice: {
			currency: 'bells',
			value: 140,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 560,
			},
		],
		variations: {
			gray: 'Gray',
		},
	},
	'retro-shades': {
		name: 'Retro Shades',
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			yellow: 'Yellow',
			green: 'Green',
			red: 'Red',
			purple: 'Purple',
			blue: 'Blue',
			gray: 'Gray',
		},
	},
	'rhinestone-shades': {
		name: 'Rhinestone Shades',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			red: 'Red',
			ochre: 'Ochre',
			purple: 'Purple',
		},
	},
	'rimmed-glasses': {
		name: 'Rimmed Glasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 157,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 630,
			},
		],
		variations: {
			black: 'Black',
			gold: 'Gold',
			gray: 'Gray',
			brown: 'Brown',
			purple: 'Purple',
		},
	},
	'round-shades': {
		name: 'Round Shades',
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			black: 'Black',
			green: 'Green',
			blue: 'Blue',
			yellow: 'Yellow',
			pink: 'Pink',
			red: 'Red',
			white: 'White',
			purple: 'Purple',
		},
	},
	'rounded-beard': {
		name: 'Rounded Beard',
		sellPrice: {
			currency: 'bells',
			value: 245,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 980,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'round-tinted-shades': {
		name: 'Round Tinted Shades',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			brown: 'Brown',
			'light-brown': 'Light brown',
			'dark-brown': 'Dark brown',
			green: 'Green',
		},
	},
	'shattered-glasses': {
		name: 'Shattered Glasses',
		sellPrice: {
			currency: 'bells',
			value: 10,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 40,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'ski-goggles': {
		name: 'Ski Goggles',
		sellPrice: {
			currency: 'bells',
			value: 245,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 980,
			},
		],
		variations: {
			white: 'White',
			yellow: 'Yellow',
			purple: 'Purple',
			pink: 'Pink',
			green: 'Green',
			orange: 'Orange',
		},
	},
	'sporty-shades': {
		name: 'Sporty Shades',
		orderable: true,
		sources: ['Nook Shopping'],
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			black: 'Black',
			white: 'White',
			pink: 'Pink',
			lime: 'Lime',
			'light-blue': 'Light blue',
		},
	},
	'square-glasses': {
		name: 'Square Glasses',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			brown: 'Brown',
			black: 'Black',
			gray: 'Gray',
			blue: 'Blue',
		},
	},
	'stache-glasses': {
		name: 'Stache & Glasses',
		sellPrice: {
			currency: 'bells',
			value: 192,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 770,
			},
		],
		variations: {
			black: 'Black',
			red: 'Red',
		},
	},
	'star-shades': {
		name: 'Star Shades',
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
		},
	},
	'steampunk-glasses': {
		name: 'Steampunk Glasses',
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			green: 'Green',
			purple: 'Purple',
		},
	},
	'sticky-rice': {
		name: 'Sticky Rice',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'superhero-mask': {
		name: 'Superhero Mask',
		orderable: true,
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'tiny-shades': {
		name: 'Tiny Shades',
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 275,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1100,
			},
		],
		variations: {
			gold: 'Gold',
			black: 'Black',
			'berry-red': 'Berry red',
		},
	},
	'tortoise-specs': {
		name: 'Tortoise Specs',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			brown: 'Brown',
			beige: 'Beige',
			black: 'Black',
		},
	},
	'triangle-shades': {
		name: 'Triangle Shades',
		orderable: true,
		sellPrice: {
			currency: 'bells',
			value: 220,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 880,
			},
		],
		variations: {
			red: 'Red',
			orange: 'Orange',
			blue: 'Blue',
			purple: 'Purple',
			green: 'Green',
			white: 'White',
			black: 'Black',
		},
	},
	'wooden-frame-glasses': {
		name: 'Wooden-frame Glasses',
		sources: ['Able Sisters'],
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			brown: 'Brown',
			'dark-brown': 'Dark brown',
		},
	},
	'hockey-mask': {
		name: 'Hockey Mask',
		sellPrice: {
			currency: 'bells',
			value: 360,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1440,
			},
		],
		variations: {
			white: 'White',
		},
	},
};

export { _accessories };
